/**
 * Registrazione del service worker Drive (/drive-sw.js, scope /autista) e flusso
 * di aggiornamento: il nuovo SW resta in attesa; la UI mostra "Aggiorna" e chiama
 * applyDriveUpdate(), che invia SKIP_WAITING e ricarica al controllerchange.
 * Registrato solo nel build di produzione (in sviluppo index.js rimuove i SW),
 * oppure con REACT_APP_DRIVE_SW=1 per test locali.
 */
export const DRIVE_SW_URL = "/drive-sw.js";
export const DRIVE_SW_SCOPE = "/autista";
export const DRIVE_UPDATE_EVENT = "drive-sw-update";

let waitingWorker = null;
let reloading = false;
let updateRequested = false;

export function driveSwEnabled(env = process.env) {
  return env.NODE_ENV === "production" || env.REACT_APP_DRIVE_SW === "1";
}

function announce(worker) {
  waitingWorker = worker;
  window.dispatchEvent(new CustomEvent(DRIVE_UPDATE_EVENT, { detail: { waiting: true } }));
}

export async function registerDriveServiceWorker({ nav = typeof navigator !== "undefined" ? navigator : null, env = process.env } = {}) {
  if (!nav || !("serviceWorker" in nav) || !driveSwEnabled(env)) return null;
  try {
    const reg = await nav.serviceWorker.register(DRIVE_SW_URL, { scope: DRIVE_SW_SCOPE });
    if (reg.waiting && nav.serviceWorker.controller) announce(reg.waiting);
    reg.addEventListener("updatefound", () => {
      const w = reg.installing;
      if (!w) return;
      w.addEventListener("statechange", () => {
        if (w.state === "installed" && nav.serviceWorker.controller) announce(w);
      });
    });
    nav.serviceWorker.addEventListener("controllerchange", () => {
      // Solo dopo "Aggiorna": al primo install clients.claim() cambia controller e non va ricaricato.
      if (reloading || !updateRequested) return;
      reloading = true;
      window.location.reload();
    });
    const check = () => reg.update().catch(() => {});
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") check();
    });
    return reg;
  } catch {
    return null;
  }
}

export function hasDriveUpdate() {
  return !!waitingWorker;
}

export function applyDriveUpdate() {
  if (!waitingWorker) return false;
  updateRequested = true;
  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  return true;
}

export function __resetDriveSw() {
  waitingWorker = null;
  reloading = false;
  updateRequested = false;
}
